import { IOpenApiService } from "services/models/ApiService";
import { delay } from "utils";

export class MockOpenApiService implements IOpenApiService {
  getTaskStatus(path: string): Promise<Response> {
    return delay(() => {
      throw new Error("Method not implemented.");
    });
  }
}
